// MediaData.js
export const MEDIA_ITEMS = [
  {
    image: { src: "media jamming.png", alt: "media jamming.png" },
    link: {
      href: "https://www.uottawa.ca/en/news-all/uottawa-researchers-develop-ai-protect-wireless-networks-jamming-attacks",
      label:
        "https://www.uottawa.ca/en/news-all/uottawa-researchers-develop-ai-protect-wireless-networks-jamming-attacks",
    },
    headline: "uOttawa researchers develop AI to protect wireless networks from jamming attacks",
  },
  {
    image: { src: "med8.jpg", alt: "med8" },
    link: {
      href: "https://issuu.com/engineeringdimensions/docs/winter2025",
      label: "https://issuu.com/engineeringdimensions/docs/winter2025",
    },
    headline:
      '"Engineers Lead $1 Million Autonomous Vehicle Research Project"  (Engineering Dimensions, PEO, Winter 2025 Edition)',
  },
  {
    image: { src: "med2.jpg", alt: "med2" },
    link: {
      href: "https://obj.ca/how-uottawa-empowers-local-startup-success-through-rd-collaborations/",
      label: "https://obj.ca/how-uottawa-empowers-local-startup-success-through-rd-collaborations/",
    },
    headline: "How uOttawa empowers local startup success through R&D collaborations  |  3 December 2024",
  },
  {
    image: { src: "media_2.jpg", alt: "media_2" },
    link: {
      href: "https://www.kanatanorthba.com/multiaccess-edge-computing-kanata-north/",
      label: "https://www.kanatanorthba.com/multiaccess-edge-computing-kanata-north/",
    },
    headline: "Kanata Networker, Multi-access edge computing accelerated in Kanata North  |  30 June 2024",
  },
  {
    image: { src: "media_1.jpg", alt: "media_1" },
    link: {
      href: "https://obj.ca/uottawas-kanata-north-campus-marks-5-years-in-tech-park/",
      label: "https://obj.ca/uottawas-kanata-north-campus-marks-5-years-in-tech-park/",
    },
    headline: "Smart Connected Vehicles Innovation Centre was featured in Ottawa Business Journal  |  1 April 2024",
  },
  {
    image: { src: "Nextcon-Media1.gif", alt: "Nextcon-Media1.gif" },
    link: {
      href: "https://directory.libsyn.com/episode/index/show/iotnorth/id/22186334",
      label: "Things Happen Podcast Series. Episode 14: Innovating Smart Connected Vehicles and Cities",
    },
    headline: "Things Happen Podcast on Libsyn  |  22 February 2022",
  },
  {
    image: { src: "med1.jpg", alt: "med1.jpg" },
    link: {
      href: "https://www.uottawa.ca/fr/nouvelles-gazette",
      label:
        "Drones, robots, voitures : le nouveau centre d’innovation de Kanata-Nord propulsera l’avenir des véhicules autonomes",
    },
    headline: "uOttawa - Gazette, le 29 octobre 2021",
  },
  {
    image: { src: "med1.jpg", alt: "med1" },
    link: {
      href: "https://www.uottawa.ca/en/gazette-news",
      label:
        "Drones, bots and self-driving cars: How this new Kanata North innovation centre will help drive the future of autonomous vehicles",
    },
    headline: "uOttawa - Gazette, 29 October 2021",
  },
  {
    image: { src: "med2.jpg", alt: "med2" },
    link: {
      href: "https://obj.ca/article/Faculty-engineering-sponsored-creating-water-cooler-moments-drive-connected-car-innovation-kanata-north",
      label: "Ottawa Business Journal, 27 Sep. 2021",
    },
    headline: "Creating ‘water cooler moments’ to drive connected car innovation in Kanata North",
  },
  {
    image: { src: "med2.jpg", alt: "med2" },
    link: {
      href: "https://obj.ca/article/faculty-of-engineering-sponsored-uottawa-kanata-north-ramping-smart-connected-vehicles-innovation-lab",
      label: "Ottawa Business Journal, 18 Dec 2019",
    },
    headline: "uOttawa Kanata North ramping up Smart Connected Vehicles Innovation Lab",
  },
  {
    // special row: has a "side image" (med7.jpg) inside the Link column in your original code
    image: { src: "med3.jpg", alt: "med3" },
    link: {
      href: "https://www.youtube.com/watch?v=YipJrqZea5E&t=3256s",
      label: "Click Here for the video",
      sideImage: { src: "med7.jpg", alt: "med7" },
    },
    headline: "CAV Canada Panel: How CAVs will impact society",
  },
  {
    image: { src: "med2.jpg", alt: "med2" },
    link: {
      href: "https://obj.ca/article/uottawa-engineering-search-safer-cities-university-ottawa-researchers-eye-new-uses-big-data-and-vehicular-crowd",
      label: "Ottawa Business Journal, 24 June 2019",
    },
    headline:
      "In search of safer cities, University of Ottawa researchers eye new uses for big data and vehicular crowd-sensing",
  },
  {
    image: { src: "med4.gif", alt: "med4" },
    imageStyle: { marginLeft: "120px" },
    link: {
      href: "https://twitter.com/TheOfficialACM/status/1083418240699772929?s=20",
      label: "ACM DSP Announcement",
    },
    headline: "ACM Distinguished Speaker Dr. Burak Kantarci",
  },
  {
    // row with NO image in your original code
    image: null,
    link: {
      href: "https://www.youtube.com/watch?v=52b8uznYf4o",
      label: "TAF Network, -",
    },
    headline: "Interview with TAFNetwork (In Turkish)",
  },
  {
    image: { src: "med5.jpg", alt: "med5" },
    link: {
      href: "https://nextconlab.ca/mpcourier-bestpaper.pdf.pdf",
      label: "Daily Courier Observer, 03/11/2016",
    },
    headline: 'CU Researchers Write "Best Paper"',
  },
  {
    image: { src: "med6.jpg", alt: "med6" },
    imageStyle: { marginLeft: "90px" },
    link: {
      href: "https://www.clarkson.edu/news/2015/news-release_2015-08-31-1.html",
      label: "Clarkson News Release, 08/31/2015",
    },
    headline: "CU Receives Support from Qualcommy",
  },
  {
    image: { src: "med5.jpg", alt: "med5" },
    link: {
      href: "https://nextconlab.ca/DCO08042015.pdf",
      label: "Daily Courier Observer, 08/04/2015",
    },
    headline: "CU's Kantarci Elected Committee Secretary",
  },
];